import SecurityIcon from "@mui/icons-material/Security";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { Configuration_URL, SSO_URL } from "../../Constants/Constants";
import { CONFIG_SSO, CONFIG_MFA } from "../../Constants/GlobalConstants";
import AxiosInstance from "../../services/AxiosInstance";
import { fetchData } from "../../services/UtilService";
import { useAlert } from "./../alerts/AlertContext";
import TwoFaSvgIcon from "./TwoFaSvgIcon.js";
import SsoIcon from "./SsoIcon.js";

function Configuration() {
  const [viewSSOMode, setSSOMode] = useState(false);
  const [ssoId, setSSOId] = useState("");
  const [loading, setLoading] = useState(false);
  const showAlert = useAlert();

  const [viewMfaMode, setMfaMode] = useState(false);
  const [mfaId, setMfaId] = useState("");

  const handleSSOChange = async (event) => {
    setLoading(true);

    if (viewSSOMode === true) {
      setSSOMode(false);
      await saveConfiguration(event.target.id, event.target.value, false);
    } else {
      try {
        const data = await fetchData(SSO_URL);
        if (data.length > 0) {
          if (data[0].active) {
            await saveConfiguration(event.target.id, event.target.value, true);
            setSSOMode(true);
          } else {
            showAlert("SSO record not activated, please check once!", "error");
          }
        } else {
          showAlert("SSO record not configured, please check once!", "error");
        }
      } catch (err) {
        showAlert("SSO record not configured, please check once!", "error");
        console.log("Failed to load SSO data");
      }
    }
    loadConfiguration();
    setLoading(false);
  };

  const handleMfaChange = async (event) => {
    setLoading(true);

    if (viewMfaMode === true) {
      setMfaMode(false);
      await saveConfiguration(event.target.id, event.target.value, false);
    } else {
      try {
        await saveConfiguration(event.target.id, event.target.value, true);
        setMfaMode(true);
      } catch (err) {
        showAlert("MFA record not configured, please check once!", "error");
        console.log("Failed to load MFA data");
      }
    }
    loadConfiguration();
    setLoading(false);
  };

  useEffect(() => {
    loadConfiguration();
  }, []);

  function loadConfiguration() {
    fetchData(Configuration_URL)
      .then((data) => {
        if (data.length > 0) {
          data.forEach((record) => {
            if (record.name === CONFIG_SSO) {
              setSSOId(record.id);
              setSSOMode(record.active);
            }
            if (record.name === CONFIG_MFA) {
              setMfaId(record.id);
              setMfaMode(record.active);
            }
          });
        }
      })
      .catch((err) => console.log("Failed to load Configuration data"));
  }

  const saveConfiguration = async (id, name, active) => {
    var config = {};
    config.id = id;
    config.name = name;
    config.active = active;

    try {
      await AxiosInstance.post(Configuration_URL, config);
      showAlert(name + " configuration saved successfully!", "success");
    } catch (error) {
      showAlert(name + " configuration save failed!", "error");
      console.error(error);
    }
  };

  return (
    <Paper sx={{ p: 3, height: "100%", backgroundColor: "transparent" }}>
      

      <Grid container spacing={3}>
        <Grid xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <SsoIcon sx={{ mr: 1.5, color: "primary.main", fontSize: 28 }} />
            {/* <SecurityIcon sx={{ mr: 1.5, color: "primary.main", fontSize: 28 }} /> */}
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              SSO Configuration
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={viewSSOMode}
                  onChange={handleSSOChange}
                  id={ssoId}
                  value={CONFIG_SSO}
                  disabled={loading}
                />
              }
              label={
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                    Enable SSO Authentication
                  </Typography>
                  {loading && <CircularProgress size={16} sx={{ ml: 1 }} />}
                </Box>
              }
            />
          </Box>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 2, fontStyle: "italic" }}
          >
            When enabled, users will be redirected to SSO for authentication
            instead of using local credentials.
          </Typography>
        </Grid>
        <Grid xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>            
            <SecurityIcon sx={{ mr: 1.5, color: "primary.main", fontSize: 28 }} />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              MFA Configuration
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={viewMfaMode}
                  onChange={handleMfaChange}
                  id={mfaId}
                  value={CONFIG_MFA}
                  disabled={loading}
                />
              }
              label={
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                    Enable MFA Authentication
                  </Typography>
                  {loading && <CircularProgress size={16} sx={{ ml: 1 }} />}
                </Box>
              }
            />
          </Box>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 2, fontStyle: "italic" }}
          >
            When enabled, users will be redirected to MFA for authentication
            along with local credentials.
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default Configuration;
